import angular from 'angular';
import User from './user/user';
import Services from './services/services';
import Utils from './utils/utils';

let commonModule = angular.module('app.common', [
  User.name,
  Services.name,
  Utils.name
]);

export default commonModule;



// WEBPACK FOOTER //
// ./client/app/common/common.js